// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PlusBadge":"bcr_a bhc_qn bhc_qo bhc_ua bhc_cy bhc_ty bhc_gm bhc_ka"};